const generateUrl = function(id, portalId) {
    const query = '?rel=0&enablejsapi=1';
    let url;
    let parts;

    if (portalId == 0)
        url = 'https://www.youtube.com/embed/' + id + query;
    else if (portalId == 1) {
        parts = id.split("_");
        url = 'https://vk.com/video_ext.php?oid=' + parts[0] + '&id=' + parts[1] + query;
    }
    else if (portalId == 2) {
        url = 'https://rutube.ru/play/embed/' + id + query;
    }

    return url;
};

const createIframe = function(id, portalId) {
    const iframe = document.createElement('iframe');

    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('src', generateUrl(id, portalId));

    return iframe;
};

const createPreview = function(id) {
    const li = document.createElement('li');
    li.setAttribute('class','slider-tns__thumbnails-item');

    const image = document.createElement('image');
    const youtubeImgSrc = 'https://i.ytimg.com/vi/' + id + '/default.jpg';
    image.setAttribute('src', youtubeImgSrc);
    image.setAttribute('width', "120");
    image.setAttribute('height', "90");

    li.append(image);
    return li;
};

const uploadPreview = function () {
    const sliderPreviews = document.getElementById('video-previews');
    const videos = document.querySelectorAll('[data-video]');

    videos.forEach((el) => {
        const videoId = el.getAttribute('data-video');

        const preview = createPreview(videoId);
        sliderPreviews.append(preview);
    });
}
const uploadVideos = function () {
    const videos = document.querySelectorAll('[data-video]');

    videos.forEach((el) => {
        const videoId = el.getAttribute('data-video');
        const portalId = el.getAttribute('data-portal')

        const iframe = createIframe(videoId, portalId);
        el.append(iframe);
        el.removeAttribute('data-video');
    });
}
export { uploadPreview, uploadVideos };
